import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Очень удобная футболка модного фасона.  Мягкая и гладкая на ощупь ткань — это высококачественный Турецкий хлопок. Из-за дорогой цены, эта ткань в основном используется только для детской одежды. Легкая приталенность подчеркивает достоинства фигуры, а короткий свободный рукав и круглый ворот делают носку по-настоящему комфортной. Эта футболка обязательно станет вашей любимой.</p>
        <p>Белый, черный, серый меланж: 100% холопок, плотность 200гр<br/>
        Остальные цвета: 90% хлопок, 10% лайкра, плотность 180гр</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`woman_tee`],
      sizeInfo: `woman_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
